"use strict";

import Vue from 'vue'
import allBetMixin from '@/vue/mixins/allBet'

Vue.component('over-under',{
  mixins: [allBetMixin],  
  name:'over-under',
  template: `
    <span class="txt">
      <template v-if="event.od">
        <template v-if="event.od[plyType]">
          <template v-if="event.od[plyType][betType]">
            <template v-if="event.od[plyType][betType][matchId]">
              <template v-if="oddValidation(event)">
                {{ ou }}
              </template>
            </template>
          </template>
        </template>
      </template>
    </span>
  `,
  props: {
    event: null,
    plyType: null,
    betType: null,
    match: null,
    lang: null,
    ouType: null,
  },
  watch: {
    'event': {
      handler(val, oldVal) {
        //cater for 3 match only
        if(this.match == 0 || this.match == 'a')
          this.matchId = 'a'
        else if(this.match == 1 || this.match == 'b')
          this.matchId = 'b'
        else if(this.match == 2 || this.match == 'c')
          this.matchId = 'c'
        else
          this.matchId = 'd'
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ou : (val) => {
      var split = val.event.od[val.plyType][val.betType][val.matchId].hdp.split('/',2)
      var returnValue = ''
      if(split.length > 1) {
        returnValue = split[0] + '/' + split[1]
      } else {
        returnValue = split[0]
      }

      return (val.lang) ? val.lang : returnValue
    },
  },
  data() {
    return {
      matchId: null,
    }
  },
  methods:{
    oddValidation(event){
      var param = {}
      param.odds = parseFloat(event.od[this.plyType][this.betType][this.matchId][this.team])
      param.hdp = event.od[this.plyType][this.betType][this.matchId]['hdp']      
      param.bettype = parseInt(this.betType)
      param.oddstype = (this.$store.getters.selectedBettype.betTypId == 5) ? this.$store.getters.oddTypesList.EU.key : this.$store.getters.account.oddsType
      return this.validateOddHdp(param)
    },
  }
})



// WEBPACK FOOTER //
// ./resources/wob/vue/components/over-under.js